<template>
  <div class="subscription-information border-radius-large padding-right-ml padding-left-ml padding-top-l padding-bottom-m">
    <subscription-info
      title-text="Name"
      :info-text="`${firstName} ${lastName}`|| ''"
    />
    <subscription-info
      v-if="!isCancelled"
      title-text="Plan Type"
      :info-text="productName"
    />
    <subscription-info
      title-text="Status"
      :info-text="statusText"
      :text-color="isCancelled ? 'red' : ''"
    />
    <subscription-info
      v-if="isCancelled"
      :title-text="cancellationDateText"
      :info-text="canceledAtFormatted || ''"
    />
    <subscription-info
      v-else-if="isActiveOrTrial"
      title-text="Next Billing Date"
      :info-text="nextPaymentDateFormatted || ''"
    />
  </div>
</template>

<script lang="ts" setup>

import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { SubscriptionStateEnum } from '@riseupil/billing-client';
import moment from 'moment';
import SubscriptionInfo from './SubscriptionInfo.vue';
import { useSubscriptionStore } from '../../stores/subscription';
import { useSessionStore } from '../../stores/session';

const { isCancelled, subscription, isActiveOrTrial } = useSubscriptionStore();
const sessionStore = useSessionStore();
const {
  firstName,
  lastName,
} = storeToRefs(sessionStore);

const statusText = computed(() => {
  if (isCancelled) {
    return 'Cancelled';
  }
  if (subscription?.canceledAt) {
    return `Cancelled – ${-moment().diff(subscription?.nextPaymentDate, 'days')} days left`;
  }
  if (subscription?.status === SubscriptionStateEnum.Active) {
    return 'Active';
  }
  if (subscription?.status === SubscriptionStateEnum.Free) {
    return 'Free';
  }
  if (subscription?.status === SubscriptionStateEnum.Trial) {
    return `Trial – ${-moment().diff(subscription?.nextPaymentDate, 'days')} days left`;
  }
  return '';
});

const canceledAtFormatted = subscription && subscription.canceledAt && moment(subscription.canceledAt).format('MMMM D, YYYY');
const cancellationDateText = subscription?.status === SubscriptionStateEnum.Dormant ? 'Expired On' : 'Expires On';
const nextPaymentDateFormatted = subscription && moment(subscription?.nextPaymentDate).format('MMMM D, YYYY');
const productName = subscription?.productName;
</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
.subscription-information {
  color: $riseup_black;
  background-color: $riseup_white;
}
</style>
